import type { ReadConfig } from 'api-read-hook';

import { useApiRead } from 'api-read-hook';

import * as Upload from './Upload';
import * as User from './User';

export type V = {
  '@id': string;
  '@type': 'WishlistIdea';
  id: string;
  title: string;
  body: string | null;
  uploads: Array<Upload.BaseView>;
  state: string;
  serviceOrder: {
    '@id': string;
    '@type': 'ServiceOrder';
    name: string;
    referenceNumber: string | null;
    ideaIds: Array<string>;
    status: string;
  } | null;
  position: number;
  author: User.BaseView | null;
  createdAt: string;
  updatedAt: string;
  cancelledAt: string | null;
  cancelledBy: User.BaseView | null;
  comments: Array<{
    '@id': string;
    '@type': 'Comment';
    id: string;
    body: string;
    author: User.BaseView;
    isInternal: boolean;
    createdAt: string;
    uploads: Array<Upload.BaseView>;
  }>;
};

export type V_Detail = {
  '@id': string;
  '@type': 'WishlistIdea';
  id: string;
  title: string;
  body: string | null;
  uploads: Array<Upload.BaseView>;
  state: string;
  serviceOrder: string | null;
  position: number;
  author: User.BaseView | null;
  createdAt: string;
};

export type W_Create = {
  company: string;
  title: string;
  body: string | null;
  uploads: Array<string>;
};

export type W_Update = {
  title: string;
  body: string | null;
};

export type WishlistIdeaLink_W = {
  serviceOrder: string | null;
};

export type WishlistIdeaMove_W = {
  state: string | null;
};

export type WishlistIdeaReorder_W_partial = Partial<{
  wishlistIdea: string | null;
  state: string | null;
  position: number | null;
}>;

export function useReadItem(id: string, options?: ReadConfig) {
  return useApiRead<V>(`/wishlist-ideas/${id}`, options);
}
